import React, { useEffect, useState } from 'react';
import './ArticleFull.css';
import { useTranslation } from './Translator';
import DOMPurify from 'dompurify';
import { format, parseISO } from 'date-fns';

function fixImg(body, baseUrl) {
  return body.replace(/<img[^>]*>/g, (match) => {
    const srcMatch = match.match(/src="([^"]*)"/);
    const src = srcMatch ? srcMatch[1] : '';
    return `<div class="illustration"><img src="${baseUrl}${src}" alt="Illustration" /></div>`;
  });
}

function fixVideo(body, baseUrl) {
  return body.replace(/<video[\s\S]*?<\/video>/g, (match) => {
    // Extract the source URL from the source tag
    const sourceMatch = match.match(/<source[^>]*src="([^"]*)"/i);
    if (!sourceMatch) return match; // Return original if no source found
    
    const src = sourceMatch[1];
    const newSrc = src.startsWith('http') ? src : `${baseUrl}${src}`;
    
    // Return the video with updated source URL
    return match.replace(
      /<source[^>]*src="[^"]*"[^>]*>/i,
      `<source src="${newSrc}" type="video/mp4">`
    );
  });
}

function ArticleFull({ title, body, id, date, featuredImage }) {
  const baseUrl = process.env.REACT_APP_FEED_URL;
  const { translate } = useTranslation();
  const formattedDate = format(parseISO(date), 'MMMM d, yyyy');

  const sanitizedBody = DOMPurify.sanitize(body);
  const illustratedBody = fixImg(sanitizedBody, baseUrl);
  const processedBody = fixVideo(illustratedBody, baseUrl);

  const [displayTitle, setDisplayTitle] = useState(title);
  const [displayBody, setDisplayBody] = useState(processedBody);

  useEffect(() => {
    translate(title).then(setDisplayTitle);
    translate(processedBody).then(setDisplayBody);
  }, [title, processedBody, translate]);

  return (
    <div id={id} className="blog-article">
      <h2>{displayTitle}</h2>
      {featuredImage && <img className="featured-image" src={featuredImage} alt={title} />}
      <div className="article-date">{formattedDate}</div>
      <div dangerouslySetInnerHTML={{ __html: displayBody }} />
    </div>
  );
}

export default ArticleFull;
